import type {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import type {
	DeleteAgenticWorkerResultInput,
	DeleteAgenticWorkerResultMutation,
} from './__generated__/DeleteAgenticWorkerResultMutation.graphql';
import type {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

const mutation = graphql`
	mutation DeleteAgenticWorkerResultMutation($input: DeleteAgenticWorkerResultInput!) {
		deleteAgenticWorkerResult(input: $input) {
			deleted
			result {
				id
				state
				hidden
				actedBy {
					fullName
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<DeleteAgenticWorkerResultInput>,
	onSuccess?: RelayOnCompleted<DeleteAgenticWorkerResultMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<DeleteAgenticWorkerResultMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
